module.exports = __webpack_public_path__ + "media/es-company.5a37ec0d.mp4";